var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { CompanyPermissionsClient, GetUserCompanyAccessViewPaginatedQuery, PaginatedEnumerableOfUserCompanyAccessQuery, SortDescription, SortDirection, UsersClient, SitesClient, GetSiteListQuery } from "@/app/api/battery-portal-api";
import RouteNames from "@/app/router/routes";
import { LoginState } from "@/app/store/modules/login.state";
import { HttpHelper } from "@/app/utils/http-helper";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
const usersClient = new UsersClient(window.apiUrl);
const accessClient = new CompanyPermissionsClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
let CompanyUsersVue = class CompanyUsersVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        this.sites = [];
        this.query = new GetUserCompanyAccessViewPaginatedQuery({
            companyId: this.companyId,
            pageNo: 1,
            pageSize: 100,
            includeDeleted: false
        });
        this.data = new PaginatedEnumerableOfUserCompanyAccessQuery();
        this.sorter = new Sorter(new SortDescription({
            fieldName: "UserName",
            direction: SortDirection.Ascending
        }));
    }
    // methods
    created() {
        this.getLookups();
        this.search();
    }
    ;
    mounted() {
    }
    ;
    getLookups() {
        siteClient
            .getListPOST(new GetSiteListQuery({
            companyId: this.companyId,
            includeDeleted: false
        }))
            .then((response) => {
            var sites = (response || []).map((item) => {
                return {
                    value: item.siteId,
                    text: item.siteName
                };
            });
            this.sites = [{ value: null, text: `Any site` }].concat(sites);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    // get
    search() {
        if (!this.canSearch)
            return;
        if (this.working)
            return;
        this.working = true;
        accessClient
            .search(this.query)
            .then(response => {
            this.data = new PaginatedEnumerableOfUserCompanyAccessQuery();
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        this.search();
    }
    ;
    // set
    edit(user) {
        this.$router.push({ name: RouteNames.User, params: { id: user.userId.toString() } });
    }
    ;
    archive(user) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this user?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            usersClient
                .delete(user.userId)
                .then(() => {
                user.whenDeleted = new Date();
                Notifier.onOk(`User # ${user.userId} has been successfully archived.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore(user) {
        if (this.working)
            return;
        this.working = true;
        usersClient
            .restore(user.userId)
            .then(() => {
            user.whenDeleted = undefined;
            Notifier.onOk(`User # ${user.userId} has been successfully restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    unlock(user) {
        if (this.working)
            return;
        this.working = true;
        usersClient
            .unlock(user.userId)
            .then(() => {
            user.whenLockoutEnds = undefined;
            Notifier.onOk(`User # ${user.userId} has been successfully unlocked.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    reload() {
        this.search();
    }
    ;
    // computed
    get site() {
        return this.sites.filter(item => {
            return (item.value == this.query.siteId);
        })[0] || null;
    }
    ;
    set site(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
    get canSearch() {
        return this.companyId ? true : false;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    get isPowerShield() {
        return this.loginState.isPowerShield;
    }
    ;
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], CompanyUsersVue.prototype, "loginState", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], CompanyUsersVue.prototype, "companyId", void 0);
__decorate([
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    Watch("query.userId"),
    Watch("query.siteId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanyUsersVue.prototype, "search", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanyUsersVue.prototype, "onSortChanged", null);
CompanyUsersVue = __decorate([
    Component({
        name: "CompanyUsersVue",
        expose: ["reload"]
    })
], CompanyUsersVue);
export default CompanyUsersVue;
